import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Board Roles',
    href: '#board-roles'
  }, {
    name: 'Career',
    href: '#career'
  }, {
    name: 'Publications',
    href: '#publications'
  }, {
    name: 'Education',
    href: '#education'
  }, {
    name: 'Media',
    href: '#media'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-offwhite/95 backdrop-blur-sm shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-135">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-136">
        <a href="#home" className="font-serif text-xl md:text-2xl font-semibold tracking-wide text-navy" data-id="element-137">
          R.M. Oblath
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-138">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-navy-light hover:text-gold transition-colors" data-id="element-139">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-navy" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-140">
          {mobileMenuOpen ? <X size={24} data-id="element-141" /> : <Menu size={24} data-id="element-142" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-offwhite shadow-lg border-t border-gray-200" data-id="element-143">
          <nav className="flex flex-col px-6 py-4 space-y-4" data-id="element-144">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-navy-light hover:text-gold transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-145">
                {link.name}
              </a>)}
          </nav>
        </div>}
    </header>;
}